import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';

// import floor from './floor/index';
import common from './common';
import introduce from './introduce';
import set from './set';
import xiaokong from './xiaokong';
import order from './order';
import baobei from './baobei';
import fenxiao from './fenxiao';
import dongtai from './dongtai';
import fabu from './fabu';

Vue.use(Router)

var layoutChildren=common;

layoutChildren = layoutChildren.concat(common);
layoutChildren = layoutChildren.concat(introduce);
layoutChildren = layoutChildren.concat(set);
layoutChildren = layoutChildren.concat(xiaokong);
layoutChildren = layoutChildren.concat(baobei);
layoutChildren = layoutChildren.concat(order);
layoutChildren = layoutChildren.concat(fenxiao);
layoutChildren = layoutChildren.concat(dongtai);
layoutChildren = layoutChildren.concat(fabu);

// console.log(layoutChildren,'layoutChildren');

var router = new Router({ 
  routes: [{
      path: '/',
      name: 'Layout',
      component: resolve =>require(['@/components/layout/index'],resolve),
      children: layoutChildren
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve =>require(['@/page/login'],resolve),
    },
    {
      path: '/gzh',
      name: 'Gzh',
      component: resolve =>require(['@/page/gzh'],resolve),
    }
  ]
});

router.beforeEach((to, from, next) => {
  console.log(!localStorage.getItem("userInfo"),'localStorage.getItem("userInfo")');
  console.log(to.name,'name');
  if(!localStorage.getItem("userInfo")&&to.name!='Login'){
    console.log(99998);
    next({path:'/login'});
  }
  // else{
    
  // }
  next();
  // 用户信息
  if(!store.state.userInfo){
    store.state.userInfo=JSON.parse(localStorage.getItem("userInfo"));
  }
  // 项目id
  if(!store.state.itemId){
    store.state.itemId=localStorage.getItem("itemId");
  }
  // 项目类型
  if(!store.state.itemType){
    store.state.itemType=localStorage.getItem("itemType");
  }
  // 模块类型
  if(!store.state.modulesAct){
    store.state.modulesAct=localStorage.getItem("modulesAct");
  }
  // 设置内容（步骤）
  if(!store.state.stepKey){
    store.state.stepKey=localStorage.getItem("stepKey");
  }
  next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js